import { render, staticRenderFns } from "./CancelNextPlan.vue?vue&type=template&id=0166615a&scoped=true&"
import script from "./CancelNextPlan.vue?vue&type=script&lang=js&"
export * from "./CancelNextPlan.vue?vue&type=script&lang=js&"
import style0 from "./CancelNextPlan.vue?vue&type=style&index=0&id=0166615a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0166615a",
  null
  
)

/* custom blocks */
import block0 from "./CancelNextPlan.vue?vue&type=custom&index=0&blockType=i18n&lang=yml&locale=ru"
if (typeof block0 === 'function') block0(component)
import block1 from "./CancelNextPlan.vue?vue&type=custom&index=1&blockType=i18n&lang=yml&locale=en"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCheckbox,VIcon})
